<style scoped>
@media only screen and (max-width: 992px) {
  nav {
    padding-left: 0px;
  }
}

@media only screen and (min-width: 992px) {
  nav {
    padding-left: 332px;
  }
}

a.brand-logo {
  font-weight: 200;
}

a.brand-logo span {
  font-weight: 500;
}
.seclst {
  width: 100% !important;
}

/* @media only screen and (max-width: 992px) {
  nav {
    padding-left: 0px;
    padding-right: 0px;
  }
} */
</style>

<template lang="pug">
  div
    nav.inomph-red
      .nav-wrapper
        a.brand-logo(href="#") Inom.ph
          span Admin
        a.button-collapse.sidenav-trigger(href="#", data-target="slide-out")
          i.material-icons menu
    ul#slide-out.sidenav.sidenav-fixed.secondary-background
      li
        div.user-view
          div.background
            img.responsive-img(src="../assets/avatar-background.png")
          a(href="#!user")
            img.circle(src="../assets/avatar-placeholder.png")
          a(href="#!name")
            span.white-text.name {{user.displayName}}
          a(href="#!email")
            span.white-text.email {{user.email}}
      //- li
      //-   router-link.sidenav-close(:to="{name: 'orders'}") Orders
      li
        ul
          li(v-bind:class="this.$route.name === 'orders' ? 'active': ''")
            router-link.collapsible-header.waves-effect.waves-blue(:to="{name: 'orders'}")
              i.material-icons shopping_cart
              | Orders
      //- li
      //-   router-link.sidenav-close(:to="{name: 'deliveryJobs'}" v-bind:class="activeRoute === 'delivery-jobs' ? 'active': ''") Delivery Jobs
      //-    span.new.badge( data-badge-caption="New", v-if='this.$store.state.config.deliveryCount') {{this.$store.state.config.deliveryCount}}
      li
        ul
          li(v-bind:class="this.$route.name === 'deliveryJobs' ? 'active': ''")
            router-link.collapsible-header.waves-effect.waves-blue(:to="{name: 'deliveryJobs'}")
              i.material-icons commute
              | Delivery Jobs
              span.new.badge( data-badge-caption="New", v-if='this.$store.state.config.deliveryCount') {{this.$store.state.config.deliveryCount}}
      li
        ul.collapsible(data-collapsible="accordion")
          li.active
            a.collapsible-header.waves-effect.waves-blue
              i.material-icons account_circle
              | Users
              i.material-icons.right(style='margin-right:0;') arrow_drop_down
            //- .collapsible-body
            .collapsible-body
              ul
                li(v-bind:class="this.$route.name === 'suppliers' ? 'active': ''")
                  router-link(:to="{name: 'suppliers'}")
                    i.material-icons store
                    |Staff
                li(v-bind:class="this.$route.name === 'reseller' ? 'active': ''")
                  router-link(:to="{name: 'reseller'}")
                    i.material-icons swap_horiz
                    | Resellers
                    span.new.badge( data-badge-caption="New", v-if='filterbystatus.length') {{filterbystatus.length}}
                li(v-bind:class="this.$route.name === 'shopper' ? 'active': ''")
                  router-link(:to="{name: 'shopper'}")
                    i.material-icons people_outline
                    | Shopper
      li
        ul
          li(v-bind:class="this.$route.name === 'SendSms' ? activeClass: ''")
            router-link.collapsible-header.waves-effect.waves-blue(:to="{name: 'SendSms'}")
              i.material-icons speaker_notes
              | SMS
      li
        ul.collapsible(data-collapsible="accordion")
          li.active
            a.collapsible-header.waves-effect.waves-blue
              | Newsletters
              i.material-icons.right(style='margin-right:0;') arrow_drop_down
            //- .collapsible-body
            .collapsible-body
              ul
                li(v-bind:class="this.$route.name === 'Newsletter' ? activeClass: ''")
                  router-link(:to="{name: 'Newsletter'}")
                    i.material-icons ballot
                    | Create Newsletter
                li(v-bind:class="this.$route.name === 'Newsletter-list' ? activeClass: ''")
                  router-link(:to="{name: 'Newsletter-list'}")
                    i.material-icons ballot
                    |  Newsletter templates
                li(v-bind:class="this.$route.name === 'NewsletterSubsciber' ? activeClass: ''")
                  router-link.sidenav-close(:to="{name: 'NewsletterSubsciber'}")
                    i.material-icons supervised_user_circle
                    |   Newsletter Subscribers
                li
      //- li(v-bind:class="this.$router.currentRoute.name === 'settings' ? 'active': ''")
      //-   router-link.sidenav-close(:to="{name: 'settings'}") Settings
      li
        ul
          li(v-bind:class="this.$route.name === 'settings' ? activeClass: ''")
            router-link.collapsible-header.waves-effect.waves-blue(:to="{name: 'settings'}")
              i.material-icons settings
              | Settings
      li
        .divider
      //- li
          router-link(:to="'settings'") Settings
      li
        ul
          li
            a.collapsible-header.waves-effect.waves-blue(href="#", v-on:click='logout')
              i.material-icons logout
              | Log out
      //- li
      //-   a(href="#", v-on:click='logout') Log out
        //- pre {{activeRoute}}
      //- a.button-collapse(href="#", data-activates="slide-out")
          i.material-icons menu
</template>
<script>
/* eslint-disable no-undef */
import axios from "axios";
export default {
  data() {
    return {
      sidenav: null,
      jobRefreshInterval: null,
      resellerRefreshInterval: null,
      resellersCount: [],
      stat: "application",
      activeRouteLink: "",
      activeClass: "active"
    };
  },
  computed: {
    activeRoute() {
      return this.$router.currentRoute.name;
    },
    user() {
      return this.$store.state.auth.user || {};
    },
    filterbystatus() {
      return this.resellersCount.filter(resellerlst => {
        return (
          !this.stat ||
          resellerlst.status.toLowerCase().indexOf(this.stat.toLowerCase()) > -1
        );
      });
    }
  },
  created() {
    // this.resellerRefreshInterval();
    this.resellerRefreshInterval;
    this.activeRouteLink = this.$router.currentRoute.name;
  },
  beforeDestroy() {
    clearInterval(this.resellerRefreshInterval);
  },
  mounted() {
    this.$M.Collapsible.init(document.querySelectorAll(".collapsible"));
    this.getresellersCount();
    var elems = document.querySelectorAll(".sidenav");
    this.sidenav = this.$M.Sidenav.init(elems);

    this.$store.dispatch("config/getDeliveryJobsCount");
    this.jobRefreshInterval = setInterval(this.getDeliveryJobsCount, 300000);
    // this.resellerRefreshInterval = setInterval(this.getresellersCount, 300000)
  },
  destroyed() {
    clearInterval(this.jobRefreshInterval);
  },
  methods: {
    logout() {
      return this.$store.dispatch("auth/logout").then(() => {
        this.$store.commit("config/setDeliveryJobsCount", 0);
        this.$router.replace("login");
      });
    },
    getDeliveryJobsCount() {
      this.$store.dispatch("config/getDeliveryJobsCount");
    },
    getresellersCount() {
      this.resellerRefreshInterval = setInterval(() => {
        this.$store.dispatch("auth/getAccessToken").then(accessToken => {
          axios
            .get(`${this.$config.API_URL}/admin/resellers/list`, {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            })
            .then(result => {
              this.resellersCount = result.data;
            });
        });
      }, 300000);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/app-navigation.vue